
// spartacus/services/cdc-confidential.config.ts
import { InjectionToken, PLATFORM_ID, inject, DOCUMENT } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Config, OccConfig } from '@spartacus/core';

export interface CdcConfidentialConfig {
  clientId: string;       // 'mobile_android'
  clientSecret: string;   // 'secret'
  tokenUrlBase?: string;  // commerce host (protocol + host + port)
}

export const CDC_CONFIDENTIAL = new InjectionToken<CdcConfidentialConfig>(
  'CDC_CONFIDENTIAL_CONFIG'
);

/**
 * Build CDC confidential config from Spartacus OCC baseUrl.
 * - If baseUrl is absolute: tokenUrlBase = new URL(baseUrl).origin
 * - If baseUrl is relative/empty: use browser origin (CSR) or leave empty for SSR
 */
export function cdcConfidentialFactory(): CdcConfidentialConfig {
  const cfg = inject<Config & OccConfig>(Config as any);
  const platformId = inject(PLATFORM_ID);
  const doc = inject(DOCUMENT);

  const occBaseUrl = (cfg as any)?.backend?.occ?.baseUrl?.toString().trim();

  let tokenOrigin = '';
  const isAbs = !!occBaseUrl && /^https?:\/\//i.test(occBaseUrl);

  if (occBaseUrl && isAbs) {
    // e.g. "https://api.example.com/occ/v2" -> "https://api.example.com"
    tokenOrigin = new URL(occBaseUrl).origin;
  } else {
    // Fallback to current origin on the client (CSR)
    if (isPlatformBrowser(platformId)) {
      const win = (doc?.defaultView as Window | null) ?? window;
      tokenOrigin = win?.location?.origin ?? '';
    } else {
      // SSR: if you need tokenUrlBase during SSR, inject it from server.ts later
      tokenOrigin = '';
    }
  }

  return {
    clientId: 'mobile_android',
    clientSecret: 'secret',
    tokenUrlBase: tokenOrigin,
  };
}

/** Export a ready-to-use provider */
export const CDC_CONFIDENTIAL_PROVIDER = {
  provide: CDC_CONFIDENTIAL,
  useFactory: cdcConfidentialFactory,
};
